<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="客人昵称"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="头像"
        prop="basic.avatar"
        show-overflow-tooltip
        width="80px"
      >
        <template #default="{ row }">
          <el-avatar shape="square" :size="40" fit="fill" :src="row.basic.avatar || defaultAvatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="姓名"
        prop="basic.name"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="最近的消息"
        prop="basic.text"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="更新时间"
        prop="basic.text"
        show-overflow-tooltip
      >
        <template #default="{ row }">
        {{ moment(row.updated).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="100px"
      >
        <template #default="{ row }">
          <el-button
            type="text"
            @click="handleReply(row)"
          >
            回复
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <detail ref="detail" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { getChatList } from '@/api/chat'
import defaultAvatar from '@/assets/defaultAvatar.png'
import Detail from './detail.vue'
import { mapState } from 'vuex'
export default {
  name: 'Chat',
  components: { Detail },
  data() {
    return {
      moment,
      defaultAvatar,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        step: 2,
        page: 1,
        size: 10,
        keyword: '',
      },
    }
  },
  computed: {
    noticeCount() {
      return this.$store.state.notice.noticeCount
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to, from)
      if (to.path == '/customer/chat') {
        const peopleId = this.$route.params.peopleId
        if(peopleId) {
          this.queryForm.peopleId = peopleId
        }
        this.fetchData()
      }
    },
    noticeCount () {
      this.fetchData()
    }
  },
  created() {
    console.log('noticeCount', )
    this.fetchData()
  },
  methods: {
    handleReply(row) {
      this.$refs['detail'].showEdit(row)
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      delete this.queryForm.peopleId
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await getChatList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.avatar {
   height: 64px;
   width: 128px;
   border-radius: 8px;
}
.mr-10 {
  margin-right: 10px;
}
</style>
